import { createContext } from 'react'

const MobileContext = createContext()

export default MobileContext
